<template>
  <ChipGeneric
    :item="computed_item"
    :key="'item_'+item.value"
    @update="chip_clicked"
  />
</template>
    
<script>
  import { mapState, mapGetters } from 'vuex';
  import QUnit from '@/api/QUnit';
  import ChipGeneric from '@/components/explorer/chips/ChipGeneric';
    
  export default {
    name: 'DateFieldChip',
    
    props: {
      item: {type: Object},
      disable: {
        type: Boolean,
        default: false,
      },
    },
    
    components: {
      ChipGeneric,
    },
    
    data: () => ({
      date_fields: [],
    }),
    
    computed: {
      ...mapState(['users']),
      ...mapGetters(['centro_id']),
      computed_item() {
        return  {
                  readable: this.text,
                  readableValue: this.value,
                }
      },
      business_process() {
        return this.$route.query.business_process;
      },
      text() {
        return this.item.readable || 'Campo de fechas';
      },
      value() {
        if (this.date_fields && this.date_fields.length > 0) {
          let dateField = this.date_fields.find(date => date.id ==  this.item.value);
          if (dateField && dateField.name) {
            return dateField.name;
          }
        }
        return this.item.readableValue || this.item.value;
      },
    },
    
    mounted(){
      this.setDatesFields();
    },
    
    methods: {
      async setDatesFields() {
       // Don't worry, the API call is cached on the frontend ;-)
       const data = await QUnit.getFieldsByTypeToCollectForFiltering(
         this.centro_id,
         this.business_process
       );
       this.date_fields = data.fields;
     },
      chip_clicked(){
        let new_item = this.item;
        new_item['type'] = '';
        this.$emit('update',new_item);
      },
    },
  }    
</script>
